/** @format */

'use strict';
// Generated by jhipster/controller/genericOverviewWithPaging.ftl

angular
	.module('emsApp')
	.controller('CompanyTypeController', function(
		$scope,
		$rootScope,
		$state,
		$stateParams,
		$q,
		AlertService,
		CompanyTypeFactory,
		FindAllCompanyTypesByQueryParamsNonPageableFactory,
		NoPagingCompanyTypeFactory
	) {
		$scope.companyTypeList = [];
		$scope.predicate = 'id';
		$scope.ascending = false;
		// a custom hook could be implemented here to add additional fields: custom/jhipster/controller/overview/additional-fields.ftl

		$scope.goToNewState = function() {
			// this overview is NOT mapped, it is the main overview
			$state.go('companytype.list.new');
		};

		$scope.goToEditState = function(companyType) {
			// this overview is NOT mapped, it is the main overview
			$state.go('companytype.list.edit', { companyTypeId: companyType.id });
		};

		$scope.getCompanyTypeList = function() {
			FindAllCompanyTypesByQueryParamsNonPageableFactory.query(
				{
					sort: [$scope.predicate + ',' + ($scope.ascending ? 'asc' : 'desc')],
				},
				function(result, headers) {
					$scope.totalItems = headers('X-Total-Count');
					$scope.totalCountIsKnownAtTheMoment = true;
					$scope.companyTypeList = result;
				}
			);
		};
		$scope.loadAll = function() {
			$scope.getCompanyTypeList();
		};

		$scope.loadPage = function() {
			$scope.loadAll();
		};

		$scope.singleDelete = function(id) {
			$scope.selectedCompanyTypeId = id;
			$('#deleteCompanyTypeConfirmation').modal('show');
		};

		$scope.confirmSingleDelete = function() {
			CompanyTypeFactory.delete(
				{ id: $scope.selectedCompanyTypeId },
				function() {
					$scope.loadAll();
					$('#deleteCompanyTypeConfirmation').modal('hide');
				},
				function(error) {
					$('#deleteCompanyTypeConfirmation').modal('hide');
					AlertService.error(error.data.message, error.data.params);
				}
			);
		};

		$scope.loadPage();

		$scope.getSortIcon = function(itemName) {
			if ($scope.predicate === itemName) {
				if ($scope.ascending) {
					return 'glyphicon-sort-by-attributes';
				} else {
					return 'glyphicon-sort-by-attributes-alt';
				}
			} else {
				return 'glyphicon-sort';
			}
		};
	});
